import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "menu", "hiddenField", "sortField", "sortDir"]
  static values = { open: Boolean, allColumns: Array }

  connect() {
    this.openValue = false

    // Store all available columns in their original order
    if (!this.hasAllColumnsValue) {
      const checkboxes = this.element.querySelectorAll('input[type="checkbox"]')
      this.allColumnsValue = Array.from(checkboxes).map(cb => cb.dataset.column)
    }

    // Listen for other dropdowns opening
    this.closeHandler = this.closeFromOtherDropdown.bind(this)
    window.addEventListener("dropdown:open", this.closeHandler)
  }

  disconnect() {
    window.removeEventListener("dropdown:open", this.closeHandler)
  }

  toggle(event) {
    this.openValue = !this.openValue
    event.preventDefault()
  }

  openValueChanged() {
    if (this.openValue) {
      // Notify other dropdowns to close
      window.dispatchEvent(new CustomEvent("dropdown:open", { detail: { source: this.element } }))
      this.menuTarget.classList.remove("hidden")
      this.buttonTarget.setAttribute("aria-expanded", "true")
    } else {
      this.menuTarget.classList.add("hidden")
      this.buttonTarget.setAttribute("aria-expanded", "false")
    }
  }

  closeFromOtherDropdown(event) {
    // Close this dropdown if another dropdown opened
    if (event.detail.source !== this.element) {
      this.openValue = false
    }
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.openValue = false
    }
  }

  toggleColumn(event) {
    const checkbox = event.currentTarget
    const columnName = checkbox.dataset.column

    // Get current selected columns
    const currentValue = this.hiddenFieldTarget.value
    let selectedColumns = currentValue ? currentValue.split(',').map(c => c.trim()) : []

    // Toggle the column
    if (checkbox.checked) {
      // Add column if not already present
      if (!selectedColumns.includes(columnName)) {
        selectedColumns.push(columnName)
      }
    } else {
      // Remove column
      selectedColumns = selectedColumns.filter(c => c !== columnName)
    }

    // Sort selected columns by their original order
    const orderedColumns = this.allColumnsValue.filter(col => selectedColumns.includes(col))

    // Update hidden field
    this.hiddenFieldTarget.value = orderedColumns.join(',')

    // Submit the form
    const form = this.element.closest("form")
    if (form) {
      form.requestSubmit()
    }
  }

  sortColumn(event) {
    event.stopPropagation()

    const button = event.currentTarget
    const columnName = button.dataset.column
    const direction = button.dataset.direction

    const currentSortField = this.sortFieldTarget.value
    const currentSortDir = this.sortDirTarget.value

    // Don't do anything if clicking the currently active sort button
    if (currentSortField === columnName && currentSortDir === direction) {
      return
    }

    // Set new sorting
    this.sortFieldTarget.value = columnName
    this.sortDirTarget.value = direction

    // Submit the form
    const form = this.element.closest("form")
    if (form) {
      form.requestSubmit()
    }
  }
}
